import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserSession } from '../../interfaces/user-session';
import { BehaviorSubject, Observable } from 'rxjs';
import { UtilityFunctions } from '../../utilities/utility-functions';

@Injectable({
    providedIn: 'root'
})

export class BlobService {

    public _apiBaseUrl: string = "";

    public constructor(private http: HttpClient, @Inject("API_BASE_URL") apiBaseUrl: string) {

        this._apiBaseUrl = apiBaseUrl;
    }

    public getBlobBase64String = (blobUrl: string): Observable<string | null> => {

        let result: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
        const blobFullPath: string = this.getAvatarFullPath(blobUrl);

        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }), responseType: 'blob' as 'json' };

            this.http.get(blobFullPath, httpOptions).subscribe((blob: any) => {

                this.convertBlobToBase64(blob).then(base64String => {

                    result.next(base64String);
                    result.complete();

                }).catch(error => {

                    result.next(error);
                });

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public convertBlobToBase64 = (blob: Blob): Promise<string> => {

        return new Promise((resolve, reject) => {

            const reader = new FileReader();
            reader.readAsDataURL(blob);

            reader.onloadend = () => {

                const base64data = reader.result as string;
                resolve(base64data);
            };

            reader.onerror = error => {

                reject(error);
            };
        });
    }

    public getAvatarFullPath = (path: string): string => {

        const result: string = this._apiBaseUrl + "blob/" + path.replace(/\//g, "%2F");

        return result;
    }
}
